/**
 * Sold-out "notify me" popup: optional double-submit so the contact form
 * reaches Shopify with `?contact_posted=true` in session flow.
 * When Klaviyo Back in Stock is enabled, submit handling is left to
 * `product-notification-klaviyo.js`.
 */
(function () {
  'use strict';

  var POPUP_COMPONENT = 'popup-component';
  var SELECTOR_POPUP_CLOSE = '[data-popup-close]';
  var SELECTOR_NOTIFICATION_FORM = '[data-notification-form]';
  var SELECTOR_HEADING = '[data-product-notification-heading]';
  var CLASS_SUCCESS = 'has-success';
  var CLASS_HIDDEN = 'hidden';

  /**
   * @returns {boolean}
   */
  function isKlaviyoBisActive() {
    var v = window.klaviyoVariables;
    return Boolean(v && v.back_in_stock_enabled && v.company_id);
  }

  if (customElements.get('product-notification')) return;

  customElements.define(
    'product-notification',
    class ProductNotification extends HTMLElement {
      constructor() {
        super();
        this.notificationForm = this.querySelector(SELECTOR_NOTIFICATION_FORM);
        this.preventSubmit = true;
        this.popup = this.closest('dialog');
        this.popupClose = this.popup ? this.popup.querySelector(SELECTOR_POPUP_CLOSE) : null;
      }

      connectedCallback() {
        this.checkState();
        if (this.notificationForm && !isKlaviyoBisActive()) {
          this.notificationForm.addEventListener('submit', this.notificationSubmitEvent.bind(this));
        }
        if (this.popupClose) {
          this.popupClose.addEventListener('click', this.removeStorage.bind(this));
        }
      }

      /** Restores success UI when returning from a successful contact form post. */
      checkState() {
        if (window.location.search.indexOf('?contact_posted=true') === -1) return;
        var heading = this.querySelector(SELECTOR_HEADING);
        var popupComponent = this.closest(POPUP_COMPONENT);
        if (!this.popup || !heading || !popupComponent) return;
        heading.classList.add(CLASS_HIDDEN);
        popupComponent.classList.add(CLASS_SUCCESS);
        this.popup.removeAttribute('inert');
        if (typeof this.popup.showModal === 'function') {
          this.popup.showModal();
        } else {
          this.popup.setAttribute('open', '');
        }
      }

      /**
       * @param {SubmitEvent} ev
       */
      notificationSubmitEvent(ev) {
        if (!this.preventSubmit) return;
        ev.preventDefault();
        this.removeStorage();
        this.writeStorage();
        this.preventSubmit = false;
        this.notificationForm.submit();
      }

      writeStorage() {
        if (typeof window.sessionStorage === 'undefined') return;
        window.sessionStorage.setItem('notification_form_id', this.notificationForm.id);
      }

      removeStorage() {
        if (typeof window.sessionStorage === 'undefined') return;
        window.sessionStorage.removeItem('notification_form_id');
      }
    }
  );
})();
